import {createSlice} from '@reduxjs/toolkit'

export const allProspectsCountSlice = createSlice({
  name: 'allProspects',
  initialState: {
    value: 0,
    savedProspectsListCount: 0
  },
  reducers: {
    count: (state, action) => {
      state.value = action.payload
    },
    savedProspectsCount: (state, action) => {
      state.savedProspectsListCount = action.payload
    }
  }
})

// Action creators are generated for each case reducer function
export const {count, savedProspectsCount} = allProspectsCountSlice.actions

export default allProspectsCountSlice.reducer
